module.exports = __webpack_public_path__ + "img/02.f8a34e15.jpg";